<template>
    <div class="faq-area ptb-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-9 col-md-12">
                    <div class="faq-accordion">
                        <h2>Häufig gestellte Fragen bei <span>Benovium</span></h2>

                        <accordion>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Wie schnell ist meine Webseite fertig?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Das hängt vom Umfang des Projekts ab. Eine klassische Unternehmenswebseite ist in der Regel innerhalb weniger Tage fertig. Bei komplexeren Projekten wie Online-Shops oder Webanwendungen erstellen wir gemeinsam einen realistischen Zeitplan. Wir halten Sie während der gesamten Entwicklung auf dem Laufenden.</p>
                                </template>
                            </accordion-item>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Muss ich im Voraus bezahlen?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Bei Standardprojekten arbeiten wir ohne Anzahlung. Sie sehen zuerst das Ergebnis und bezahlen erst, wenn Sie zufrieden sind. Bei größeren Projekten vereinbaren wir individuelle Zahlungsmodalitäten, die für beide Seiten fair sind.</p>
                                </template>
                            </accordion-item>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Arbeitet ihr mit WordPress?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Nein, wir setzen auf moderne, maßgeschneiderte Lösungen. Der Grund: WordPress-Seiten sind oft langsam, wartungsintensiv und ein häufiges Ziel für Sicherheitslücken. Unsere Webseiten sind schneller, sicherer und benötigen weniger laufende Wartung.</p>
                                </template>
                            </accordion-item>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Kann ich später selbst Änderungen vornehmen?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Auf Wunsch integrieren wir ein benutzerfreundliches Content-Management-System, mit dem Sie Texte, Bilder und einfache Inhalte selbst anpassen können. Für technische Änderungen oder Erweiterungen stehen wir Ihnen gerne zur Verfügung.</p>
                                </template>
                            </accordion-item>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Kümmert ihr euch auch um Hosting und Domain?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Ja, wir übernehmen auf Wunsch die komplette technische Einrichtung. Dazu gehören Domain-Registrierung, Hosting-Setup, SSL-Zertifikate und E-Mail-Konfiguration. Sie müssen sich um nichts kümmern.</p>
                                </template>
                            </accordion-item>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Was passiert nach dem Launch?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Nach der Veröffentlichung lassen wir Sie nicht allein. Kleinere Anpassungen in den ersten Wochen sind selbstverständlich inklusive. Für langfristige Betreuung bieten wir optionale Wartungspakete an, die regelmäßige Updates, Backups und technischen Support beinhalten.</p>
                                </template>
                            </accordion-item>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Was, wenn mir das Ergebnis nicht gefällt?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Ihr Feedback ist uns wichtig. Während des gesamten Projekts zeigen wir Ihnen Zwischenstände und arbeiten Ihre Wünsche ein. So stellen wir sicher, dass das Endergebnis genau Ihren Vorstellungen entspricht. Korrekturen sind Teil unseres Prozesses.</p>
                                </template>
                            </accordion-item>
                            <accordion-item>
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-button">
                                        <i class="bx bx-plus"></i>
                                        Wie erreiche ich euch bei Fragen?
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <p>Sie erreichen uns direkt per Telefon, E-Mail oder WhatsApp. Keine Warteschleifen, keine Ticketsysteme. Als Ihr persönlicher Ansprechpartner sind wir für Sie da und antworten in der Regel innerhalb von 24 Stunden.</p>
                                </template>
                            </accordion-item>
                        </accordion>
                    </div>
                </div>

                <!-- <div class="col-lg-5 col-md-12">
                    <div class="faq-image">
                        <img src="../../assets/img/faq-img1.png" alt="image">
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Accordion from "./Accordion";
import AccordionItem from "./AccordionItem";

export default {
    name: 'Faq',
    components: {
        Accordion,
        AccordionItem
    },
}
</script>